export default "__VITE_ASSET__70351ea8__"